export default __webpack_public_path__ + "static/media/Paste.2e860905.svg";